// ==============================================
// useLogout — sign out and land on a clean /login
// ==============================================

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

/**
 * Explicit sign-out for logout buttons. While `logout()` runs, AuthGuard
 * redirects to /login with `state.from` set to the current page — the
 * deep-link mechanism LoginPage uses to return you after a session expiry.
 * After a deliberate logout that state must not survive, or the next
 * sign-in (same account or a different one) is sent back to the page the
 * previous user logged out from. The trailing replace-navigation overwrites
 * that entry with a state-free /login, so login falls through to /dashboard.
 */
export function useLogout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return useCallback(async () => {
    await logout();
    navigate('/login', { replace: true });
  }, [logout, navigate]);
}

export default useLogout;
